import moment from "moment";

export default class Company {
	constructor({
		name,
		address,
		phone,
		nit,
		date_init,
		date_end,
		contac_persons,
		city,
		country,
		description,
		id,
		department,
	}) {
		this.id = id || 0;
		this.name = name || "";
		this.address = address || "";
		this.phone = phone || "";
		this.nit = nit || "";
		this.date_init = date_init !== undefined ? moment(date_init).format() : new Date();
		this.date_end = date_end !== undefined ? moment(date_end).format() : this.addDaysToDate(new Date(), 30);
		this.contac_persons = contac_persons || "";
		this.department = department || "";
		this.city = city || "";
		this.country = country || "";
		this.description = description || "";
	}

	validateCompany() {
		let valid = true;
		let invalidFields = [];
		for (const key in this) {
			if (Object.hasOwnProperty.call(this, key)) {
				const element = this[key];
				if (typeof element === "string" && element === "") {
					invalidFields.push(`CompanyModule.${key}Required`);
					valid = false;
				}
			}
		}
		if (!this.validateDates()) {
			invalidFields.push(`CompanyModule.DateInitError`);
			valid = false;
		}
		return {valid, invalidFields};
	}

	validateDates() {
		return new Date(this.date_init).getTime() <= new Date(this.date_end).getTime();
	}

	addDaysToDate(stringDate, dayNums) {
		const date = new Date(stringDate);
		return date.setDate(date.getDate() + dayNums);
	}
}
